// extracted by mini-css-extract-plugin
module.exports = {"meetingFollowUp":"MeetingFollowUp_meetingFollowUp__33hHy","label":"MeetingFollowUp_label__Hj833","values":"MeetingFollowUp_values__1jN67"};